var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditiconPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5409 1.62421C11.6737 1.49142 11.8538 1.41682 12.0417 1.41682C12.2295 1.41682 12.4096 1.49142 12.5425 1.62421L15.3758 4.45755C15.5086 4.59038 15.5832 4.77052 15.5832 4.95834C15.5832 5.14616 15.5086 5.3263 15.3758 5.45913L6.16746 14.6675C6.03465 14.8003 5.85451 14.875 5.66667 14.875H2.83333C2.64547 14.875 2.4653 14.8004 2.33247 14.6675C2.19963 14.5347 2.125 14.3545 2.125 14.1667V11.3333C2.12504 11.1455 2.19969 10.9654 2.33254 10.8325L9.41588 3.74921L11.5409 1.62421ZM9.91667 5.25159L3.54167 11.6266V13.4583H5.37342L11.7484 7.08334L9.91667 5.25159ZM12.75 6.08176L13.8734 4.95834L12.0417 3.12659L10.9183 4.25001L12.75 6.08176Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditiconPro);
export default __webpack_public_path__ + "static/media/EDITICON-Pro.9c0c0da987281f4d312d19a68f6115bc.svg";
export { ForwardRef as ReactComponent };